import { render, staticRenderFns } from "./lookGiftActive.vue?vue&type=template&id=4bbe13c8&scoped=true"
import script from "./lookGiftActive.vue?vue&type=script&lang=js"
export * from "./lookGiftActive.vue?vue&type=script&lang=js"
import style0 from "./lookGiftActive.vue?vue&type=style&index=0&id=4bbe13c8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bbe13c8",
  null
  
)

export default component.exports